module.exports = __webpack_public_path__ + "img/guardian_cleavage.e77d9ab2.png";